import React from 'react';

export interface WDayLogoProps {
  className?: string;
  style?: React.CSSProperties;
}

const WDayLogo: React.FC<WDayLogoProps> = ({ className = '', style }) => {
  return (
    <div
      className={['flex items-center gap-2', className].filter(Boolean).join(' ')}
      style={{
        height: '36px',
        display: 'inline-flex',
        alignItems: 'center',
        userSelect: 'none',
        ...style,
      }}
    >
      {/* TaskUs Icon - SVG paths from epmslogo.svg */}
      <svg
        width="34"
        height="24"
        viewBox="0 0 50 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
      >
        <path
          d="M0 1.10077H25.4537V22.2454C25.4537 29.2743 19.7557 34.9723 12.7269 34.9723C5.69802 34.9723 0 29.2743 0 22.2454V1.10077Z"
          fill="#FF006B"
        />
        <path
          d="M49.8653 1.06104L49.8653 18.0365L33.9508 18.0365C29.2632 18.0365 25.4631 14.2364 25.4631 9.54874C25.4631 4.86111 29.2632 1.06103 33.9508 1.06103L49.8653 1.06104Z"
          fill="#1F3DFF"
        />
        <path
          d="M25.4631 35.0118L25.4631 18.0364L41.3776 18.0364C46.0653 18.0364 49.8653 21.8365 49.8653 26.5241C49.8653 31.2118 46.0653 35.0118 41.3776 35.0118L25.4631 35.0118Z"
          fill="#FFD800"
        />
      </svg>

      {/* Brand Text */}
      <div
        className="flex flex-col justify-center"
        style={{
          fontFamily: "'Poppins', sans-serif",
          lineHeight: 1.05,
        }}
      >
        <span
          style={{
            fontSize: '17px',
            fontWeight: 600,
            color: 'var(--text-primary)',
            letterSpacing: '-0.02em',
          }}
        >
          TaskUs
        </span>
        <span
          style={{
            fontSize: '8px',
            fontWeight: 700,
            color: '#1F3DFF',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            marginTop: '2.5px',
          }}
        >
          WDAY - Snapshot
        </span>
      </div>
    </div>
  );
};

export default WDayLogo;
